module.exports = __webpack_public_path__ + "img/garden-4.8cc32ac3.jpeg";